import gql from "graphql-tag"

interface Cover {
  coverKey: string
  orgName: string
  status: number
}

const COVER_FRAGMENT = gql`
  fragment Cover on User {
    coverKey
    orgName
    status
  }
`

interface Session {
  sessionId: string
  ipAddress: string
  userId: string
}

const SESSION_FRAGMENT = gql`
  fragment Session on Session {
    sessionId
    ipAddress
    userId
  }
`

interface Location {
  locKey: string
  orgName: string
  status: number
}

const LOCATION_FRAGMENT = gql`
  fragment Location on Location {
    locKey
    orgName
    status
  }
`

interface Schedule {
  id: number
  providerAcctKey: string
  locKey: string
}

const SCHEDULE_FRAGMENT = gql`
  fragment Schedule on Schedule {
    id
    providerAcctKey
    locKey
  }
`

interface Provider {
  acctKey: string
  title: string
  firstName: string
  lastName: string
  degree: string
  acctType: string
  speciality: string
  status: number
  schedules: Schedule[]
}

const PROVIDER_FRAGMENT = gql`
  fragment Provider on Provider {
    acctKey
    title
    firstName
    lastName
    degree
    acctType
    speciality
    status
  }
`

interface OnlyUser {
  userId: string
  hasViewedGetStarted: boolean
}

const ONLY_USER_FRAGMENT = gql`
  fragment OnlyUser on OnlyUser {
    userId
    hasViewedGetStarted
  }
`

export interface User extends Cover {
  session: Session
  locations: Location[]
  providers: Provider[]
  user: OnlyUser
}

const USER_FRAGMENT = gql`
  fragment User on User {
    ...Cover
    session @type(name: "Session") {
      ...Session
    }
    locations @type(name: "Location") {
      ...Location
    }
    providers @type(name: "Provider") {
      ...Provider
      schedules @type(name: "Schedule") {
        ...Schedule
      }
    }
    user @type(name: "OnlyUser") {
      ...OnlyUser
    }
  }
  ${COVER_FRAGMENT}
  ${SESSION_FRAGMENT}
  ${LOCATION_FRAGMENT}
  ${PROVIDER_FRAGMENT}
  ${SCHEDULE_FRAGMENT}
  ${ONLY_USER_FRAGMENT}
`

export const GET_USER = gql`
  query getUser {
    user @rest(type: "User", path: "/v1/user") {
      ...User
    }
  }
  ${USER_FRAGMENT}
`

export const GET_STARTED = gql`
  mutation getStarted($body: any!) {
    getStarted(body: $body)
      @rest(
        path: "/v1/user/get-started"
        method: "POST"
        bodyKey: "body"
        type: "OnlyUser"
      ) {
      ...OnlyUser
    }
  }
  ${ONLY_USER_FRAGMENT}
`
